export function unavailableMedia(message) {
  const attrs = message?.contentAttributes || message?.content_attributes || {};
  const media = attrs.bcwMedia || attrs.bcw_media;
  return media?.version === 1 && media.state === 'unavailable' ? media : null;
}
export function mediaSummary(message) {
  const media = unavailableMedia(message);
  if (!media) return '';
  const types = { image: '图片', video: '视频', audio: '音频', file: '附件', sticker: '贴纸', message: '消息' };
  const reasons = { expired_link: '下载链接已失效', timeout: '暂未下载成功', missing_reference: '下载信息缺失', size_limit: '文件超过通道大小限制', processing: '正在接收视频', storage_full: '服务器空间不足，接收未完成', invalid_video: '视频内容校验失败' };
  return `${types[media.kind] || '附件'} · ${reasons[media.reason] || '暂不可用'}`;
}
